import React, { useState, Component } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormSection, TextField, SelectField, TextAreaField, FileUploadField, DisplayField } from '../components/FormComponents';
import { StatusBadge } from '../components/StatusBadge';
import { mockSuppliers } from '../data/mockData';
export function SupplierForm({
  mode = 'create'
}: {
  mode?: 'create' | 'edit' | 'signup';
}) {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  // In a real app, fetch data based on ID. Using mock for now.
  const initialData = mode === 'edit' && id ? mockSuppliers.find(s => s.id === id) : null;
  const [formData, setFormData] = useState<any>(initialData || {
    code: 'AUTO-GEN',
    name: '',
    type: '',
    category: '',
    businessType: '',
    countryOfOrigin: '',
    businessOperationCountry: '',
    localInternational: '',
    website: '',
    communicationAddress: '',
    contactPersonName: '',
    phone: '',
    mobile: '',
    email: '',
    authorizedPersonName: '',
    designation: '',
    authorizedEmail: '',
    authorizedPhone: '',
    bankName: '',
    branchName: '',
    accountName: '',
    accountNumber: '',
    routingNumber: '',
    swiftCode: '',
    status: 'Active'
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Mock save
    alert('Supplier saved successfully!');
    if (mode === 'signup') navigate('/');else navigate('/suppliers');
  };
  const isSignUp = mode === 'signup';
  return <div className={`space-y-6 ${isSignUp ? 'max-w-4xl mx-auto py-8' : ''}`} data-id="element-2735">
      {!isSignUp && <div className="flex items-center justify-between" data-id="element-2736">
          <div data-id="element-2737">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-2738">
              {mode === 'create' ? 'Create Supplier' : 'Update Supplier'}
            </h1>
            <p className="text-sm text-gray-500 mt-1" data-id="element-2739">
              Fill in the supplier details below.
            </p>
          </div>
        </div>}

      {isSignUp && <div className="text-center mb-8" data-id="element-2740">
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-2741">
            Supplier Registration
          </h1>
          <p className="text-gray-500 mt-2" data-id="element-2742">Join our procurement network</p>
        </div>}

      <form onSubmit={handleSubmit} className="bg-white shadow-sm rounded-lg border border-gray-200 p-6 md:p-8" data-id="element-2743">
        <FormSection title="General Information" data-id="element-2744">
          {mode !== 'create' && !isSignUp ? <DisplayField label="Supplier Code" value={formData.code} data-id="element-2745" /> : <TextField label="Supplier Code" name="code" value={formData.code} disabled required data-id="element-2746" />}
          <TextField label="Supplier Name" name="name" value={formData.name} onChange={handleChange} required data-id="element-2747" />

          <SelectField label="Supplier Type" name="type" value={formData.type} onChange={handleChange} required options={[{
          value: 'Firm',
          label: 'Firm'
        }, {
          value: 'Individual',
          label: 'Individual'
        }]} data-id="element-2748" />

          <SelectField label="Category" name="category" value={formData.category} onChange={handleChange} required options={[{
          value: 'Service',
          label: 'Service'
        }, {
          value: 'Goods',
          label: 'Goods'
        }, {
          value: 'Works',
          label: 'Works'
        }, {
          value: 'Others',
          label: 'Others'
        }]} data-id="element-2749" />

          <SelectField label="Business Type" name="businessType" value={formData.businessType} onChange={handleChange} required options={[{
          value: 'Limited',
          label: 'Limited'
        }, {
          value: 'Sole Proprietorship',
          label: 'Sole Proprietorship'
        }, {
          value: 'Consultant',
          label: 'Consultant'
        }, {
          value: 'Other',
          label: 'Other'
        }]} data-id="element-2750" />

          <TextField label="Country of Origin" name="countryOfOrigin" value={formData.countryOfOrigin} onChange={handleChange} required data-id="element-2751" />
          <TextField label="Business Operation Country" name="businessOperationCountry" value={formData.businessOperationCountry} onChange={handleChange} required data-id="element-2752" />

          <SelectField label="Local / International" name="localInternational" value={formData.localInternational} onChange={handleChange} options={[{
          value: 'Local',
          label: 'Local'
        }, {
          value: 'International',
          label: 'International'
        }]} data-id="element-2753" />

          <TextField label="Website" name="website" type="url" value={formData.website} onChange={handleChange} data-id="element-2754" />
          <TextAreaField label="Communication Address" name="communicationAddress" value={formData.communicationAddress} onChange={handleChange} required rows={3} data-id="element-2755" />
        </FormSection>

        <FormSection title="Contact Details" data-id="element-2756">
          <TextField label="Contact Person Name" name="contactPersonName" value={formData.contactPersonName} onChange={handleChange} required data-id="element-2757" />
          <TextField label="Phone" name="phone" value={formData.phone} onChange={handleChange} data-id="element-2758" />
          <TextField label="Mobile" name="mobile" value={formData.mobile} onChange={handleChange} required data-id="element-2759" />
          <TextField label="Email" name="email" type="email" value={formData.email} onChange={handleChange} required data-id="element-2760" />
        </FormSection>

        <FormSection title="Authorized Person" data-id="element-2761">
          <TextField label="Authorized Person Name" name="authorizedPersonName" value={formData.authorizedPersonName} onChange={handleChange} required data-id="element-2762" />
          <TextField label="Designation" name="designation" value={formData.designation} onChange={handleChange} data-id="element-2763" />
          <TextField label="Authorized Email" name="authorizedEmail" type="email" value={formData.authorizedEmail} onChange={handleChange} required data-id="element-2764" />
          <TextField label="Authorized Phone/Mobile" name="authorizedPhone" value={formData.authorizedPhone} onChange={handleChange} required data-id="element-2765" />
        </FormSection>

        <FormSection title="Bank Details" data-id="element-2766">
          <TextField label="Bank Name" name="bankName" value={formData.bankName} onChange={handleChange} required data-id="element-2767" />
          <TextField label="Branch Name" name="branchName" value={formData.branchName} onChange={handleChange} required data-id="element-2768" />
          <TextField label="Account Name" name="accountName" value={formData.accountName} onChange={handleChange} required data-id="element-2769" />
          <TextField label="Account Number" name="accountNumber" value={formData.accountNumber} onChange={handleChange} required data-id="element-2770" />
          <TextField label="Routing Number" name="routingNumber" value={formData.routingNumber} onChange={handleChange} required data-id="element-2771" />
          <TextField label="SWIFT Code" name="swiftCode" value={formData.swiftCode} onChange={handleChange} required data-id="element-2772" />
        </FormSection>

        <FormSection title="Legal Documents" data-id="element-2773">
          <FileUploadField label="Upload Documents (PDF/Image)" data-id="element-2774" />
        </FormSection>

        <FormSection title="Contract Information" data-id="element-2775">
          <TextField label="Contract Expiry Date" name="contractExpiry" type="date" value={formData.contractExpiry || ''} onChange={handleChange} required data-id="element-2776" />
          <FileUploadField label="Upload Contract Document (PDF)" data-id="element-2777" />
          {formData.contractExpiry && new Date(formData.contractExpiry) < new Date() && <div className="md:col-span-2 bg-red-50 border border-red-200 rounded-md p-3 text-sm text-red-700 flex items-center" data-id="element-2778">
                <span className="font-medium mr-1" data-id="element-2779">⚠ Contract Expired:</span>
                This supplier's contract expired on {formData.contractExpiry}.
                Please renew the contract.
              </div>}
        </FormSection>

        {mode === 'edit' && !isSignUp && initialData && <FormSection title="Performance & Status" data-id="element-2780">
            <DisplayField label="KPI Score" value={<span className="text-lg font-semibold" data-id="element-2782">
                  {initialData.kpiScore}
                </span>} data-id="element-2781" />
            <DisplayField label="Rating Percentage" value={<span className="text-lg font-semibold" data-id="element-2784">
                  {initialData.ratingPercentage}%
                </span>} data-id="element-2783" />
            <DisplayField label="Performance Status" value={<StatusBadge status={initialData.performanceStatus} data-id="element-2786" />} data-id="element-2785" />

            <SelectField label="Status" name="status" value={formData.status} onChange={handleChange} required options={[{
          value: 'Active',
          label: 'Active'
        }, {
          value: 'Inactive',
          label: 'Inactive'
        }, {
          value: 'Blacklisted',
          label: 'Blacklisted'
        }, {
          value: 'Expired',
          label: 'Expired'
        }]} data-id="element-2787" />
          </FormSection>}

        {isSignUp && <FormSection title="Account Security" data-id="element-2788">
            <TextField label="Password" name="password" type="password" required data-id="element-2789" />
            <TextField label="Confirm Password" name="confirmPassword" type="password" required data-id="element-2790" />
            <div className="md:col-span-2 flex items-center mt-4" data-id="element-2791">
              <input type="checkbox" id="terms" required className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded" data-id="element-2792" />
              <label htmlFor="terms" className="ml-2 block text-sm text-gray-900" data-id="element-2793">
                I accept the Terms & Conditions and Privacy Policy
              </label>
            </div>
          </FormSection>}

        <div className="mt-8 pt-5 border-t border-gray-200 flex justify-end space-x-3" data-id="element-2794">
          <button type="button" onClick={() => navigate(-1)} className="px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-2795">
            Cancel
          </button>
          <button type="submit" className="px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-2796">
            {isSignUp ? 'Sign Up' : 'Save Supplier'}
          </button>
        </div>
      </form>
    </div>;
}